<template>
	<div v-if="isload" class="createorder_inner_1" :id="'createorder_inner_1' + iscopy">
		<el-row style="margin-bottom:45px;">
			<el-col :span="12">
				<senderaddr ref="senderaddr" title="寄件信息" l_mode="寄件人信息-海淘"></senderaddr>
			</el-col>
			<el-col :span="12">
				<receiveraddr ref="receiveraddr" title="收件信息" l_mode="收件人信息-海淘"></receiveraddr>
			</el-col>
			<el-col :span="24">
				<packagelist ref="packagelist" title="包裹信息" l_mode="包裹信息-海淘" @formScrollTop="formScrollTop"
					@comparecountry="comparecountry"></packagelist>
			</el-col>
		</el-row>
		<el-row v-if="!btnhidden" class="footerhandler">
			<el-col :span="6" class="submitBtn_switch" style="text-align: right;color:transparent">1</el-col>
			<el-col :span="4" class="submitBtn">
				<div @click="getrate">获取报价</div>
			</el-col>
			<el-col :span="4" class="submitBtn_cancel">
				<div @click="cancel">取消</div>
			</el-col>
		</el-row>
		<el-dialog :visible.sync="showratewin" title="报价单" width="700px" :close-on-click-modal="false" lock-scroll
			:append-to-body="true" :show-close="true">

			<tableui style="width:100%;margin-top:-10px" v-loading="loading" ref="ratelist" editcell="0"
				class="ratelist" :tableData="ratelist" :columns="columns" @gridhandle="rategridhandle"
				:gridheight="gridheight" :rowclassname="setrowclass"></tableui>
		</el-dialog>
		<el-dialog :visible.sync="showwin" title="操作提示" width="650px" :close-on-click-modal="false" lock-scroll
			:show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">下单成功</span>
				</el-col>
			</el-row>
			<el-row>
				<!-- <el-col :span="5" style="text-align:right;padding-right: 20px;">
					<el-button type="warning" size="medium" @click="printmd" style="background-color:#c86f67;border-color:#c86f67">打印面单</el-button>
				</el-col> -->
				<el-col :span="5" style="text-align:right;padding-right: 20px;color: transparent;">1
					<!-- <el-button type="warning" size="medium"
						@click="perviewmd">预览面单</el-button> --></el-col>
				<el-col :span="6"><el-button type="primary" size="medium"
						@click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="5"><el-button type="success" size="medium"
						@click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="2" style="text-align: right;"><el-button size="medium"
						@click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row style="margin-top:25px">
				<el-col :span="2" style="text-align:right;color:transparent">1</el-col>
				<el-col :span="20"><el-link @click="wintips = true"
						style="color:#409EFF">预览没反应？请点这里查看解决方案</el-link></el-col>
			</el-row>
		</el-dialog>
		<el-dialog :visible.sync="wintips" center width="70%" :close-on-click-modal="true" :show-close="true"
			:append-to-body="true">
			<img src="../../static/system_01/image/tips.png" style="width:100%" />
		</el-dialog>
		<printhandler ref="printhandler" @printcallback="printcallback"></printhandler>
		<sendtype ref="sendtype" @sendtypehandle="sendtypehandle" issave="1"></sendtype>
		<orderpay ref="orderpay" @paycallback="paycallback"></orderpay>
	</div>
</template>

<script>
	import Utils from '../../lib/util.js';
	import tableui from '@/components/table/tablegrid.vue';
	import senderaddr from '@/components/address/senderaddr_ssq.vue';
	import receiveraddr from '@/components/address/receiveraddr_ssq.vue';
	import packagelist from '@/components/order/inner_package_list.vue';
	import printhandler from '@/components/order/printhandler_check.vue';
	import sendtype from '@/components/order/sendtype.vue';
	import orderpay from '@/components/cw/orderpay_online.vue';
	export default {
		components: {
			senderaddr,
			receiveraddr,
			packagelist,
			printhandler,
			tableui,
			sendtype,
			orderpay
		},
		props: {},
		data() {
			return {
				ratedisabled: true,
				syscol: '',
				orderinfo: {},
				p_pkval: '',
				loading: false,
				// pkval:'',
				iscopy: 0,
				btnhidden: false,
				sendremind: false,
				isload: false,
				checkedpmode: '',
				t_id: '',
				showwin: false,
				wintips: false,
				divclass: 'createorder_inner_1',
				showratewin: false,
				ratelist: [], //报价单
				columns: [{
						field: 'expresscom',
						title: '服务类型',
						type: 'text',
						sortable: false,
						width: '80'
					},
					{
						field: 'servicetype',
						title: '地区',
						type: 'text',
						sortable: false,
						width: '250'
					},
					{
						field: 'amount',
						title: '价格',
						type: 'text',
						sortable: false,
						align: 'right',
						width: '70'
					},
					{
						field: '',
						title: '操作',
						type: 'template',
						width: '130',
						sortable: false,
						template: [{
							type: 'link',
							title: '创建订单',
							icon: '',
							handletype: 'success',
							event: 'createorder'
						}]
					}
				], //报价单列表表头
				expresscom: '',
				expresscomname: '',
				gridheight: '350px',
				checkedexpress: {
					rateid: '', //当前报价单唯一id
					rate_id: '', //接口返回的报价唯一id
					e_code: '', //所选快递公司唯一id
					e_modename: ''
				},
				allratelist: [],
				isallrate: false,
				ratebatch:'',
				mode:'包裹管理'
			};
		},
		methods: {
			init(param) {
				var that = this;
				this.isload = false;
				this.checkedexpress = {
					rateid: '', //当前报价单唯一id
					rate_id: '', //接口返回的报价唯一id
					e_code: '', //所选快递公司唯一id
					e_modename: ''
				};
				if (param.checkedpmode != undefined) this.checkedpmode = param.checkedpmode;
				if (param.syscol != undefined) this.syscol = param.syscol;
				if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
				if (param.iscopy != undefined) this.iscopy = param.iscopy;
				if (param.t_id != undefined) this.t_id = param.t_id;
				if (this.syscol != '') {
					//debugger
					this.isload = true;
					this.$nextTick(function() {
						that.$refs.senderaddr.init({
							syscol: that.syscol,
							orderinfo: that.orderinfo,
							isznsplit: false
						});
						that.$refs.receiveraddr.init({
							syscol: that.syscol,
							orderinfo: that.orderinfo,
							isznsplit:true
						});
						that.$refs.packagelist.init({
							syscol: that.syscol,
							orderinfo: that.orderinfo,
							iscopy: that.iscopy,
							l_mode_cargo: '包裹信息列表-海淘'
						});
					});
				}
			},
			setrowclass(e) {
				if (e.row.minprice == '1') return 'minprice';
				else return '';
			},
			//获取订单信息
			getorderObj() {
				//debugger
				var that = this;
				var error = '';
				var orderinfo = {
					p_mode: this.checkedpmode
				};
				var sender = '',
					receiver = '',
					orderlist = [];
				var senderinfo={};
				var receiverinfo={};
				var orderinfo = {};
				var setlist = this.$refs.senderaddr._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.senderaddr.title + '-' + e.showname;
							sender = '';
						} else {
							if (error == '') {
								if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
									if (!that.$tool.checkidcardformat(e.value)) {
										error = that.$refs.senderaddr.title + '-' + e.showname + '格式不正确';
										sender = '';
									}
								}
							}
						}
						if (error == '') sender += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (error == '') {
						if (sender != '') {
							sender = sender.replace(/\n/g, '');
							sender = '{' + sender.substring(0, sender.length - 1) + '}';
							senderinfo = JSON.parse(sender);
						}
					}
				}
				if (error == '') {
					setlist = this.$refs.receiveraddr._data.setlist;
					if (setlist.length > 0) {
						setlist.forEach(e => {
							if (e.value == undefined) {
								e.value = '';
							}
							if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
								error = '请填写' + that.$refs.receiveraddr.title + '-' + e.showname;
								receiver = '';
							}
							if (error == '') {
								if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
									if (!that.$tool.checkidcardformat(e.value)) {
										error = that.$refs.receiveraddr.title + '-' + e.showname + '格式不正确';
										receiver = '';
									}
								}
							}
							if (error == '') receiver += '"' + e.colname + '":"' + e.value + '",';
							else return false;
						});
						if (receiver != '') {
							receiver = receiver.replace(/\n/g, '');
							receiver = '{' + receiver.substring(0, receiver.length - 1) + '}';
							receiverinfo = JSON.parse(receiver);
						}
					}
				}
				if (error == '') {
					var pageset = this.$refs.packagelist._data.pageset;
					var cargorow = this.$refs.packagelist._data.columns;
					var index = 0;
					var list = [],
						cargolist = [];
					var baginfo = '';
					pageset.forEach(e => {
						index++;
						baginfo = '';
						cargolist = [];
						e.setlist.forEach(b => {
							if (b.value == undefined) {
								b.value = '';
							}
							if (b.controltype == 'combox-input' && b.ishidden == 'False') {
								var volume = b.combox;
								for (var k = 0; k < volume.length; k++) {
									if (volume[k].value == undefined) {
										volume[k].value = '';
									}
									if (volume[k].isnull == 'False' && volume[k].value == '') {
										error = '请填写第' + index + '个包裹的' + volume[k].showname;
										break;
									}
									baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
								}
							} 
							else if (b.controltype == 'table' && b.ishidden == 'False') {
								if (b.cargolist.length > 0) {
									var cargoindex = 0;
									if (!e.isinternational)
										b.cargolist = [];
									b.cargolist.forEach(cargo => {
										cargoindex++;
										for (var col in cargo) {
											cargorow.forEach(c => {
												if (col == c.field) {
													if (c.isnull == 'False' && c.colshow ==
														'1') {
														if (cargo[col] == '') error = '第' +
															index + '个包裹的【第' + cargoindex +
															'行】' + c.title + '为空';
													}
													return false;
												}
												if (error != '') return false;
											});
											if (error != '') return false;
										}
										if (error != '') return false;
									});
								}
								//else error = '请填写第' + index + '个包裹的' + b.showname;

								if (error == '') cargolist = b.cargolist;
							} else if (b.controltype == 'addedservice_sign-insured' && b.ishidden ==
								'False') {
								//debugger
								b.addedservice.forEach(ss => {
									if (ss.d_value == 'price') {
										if (ss.ischecked) {
											if (parseFloat(ss.factprice) <= 0 || ss.factprice ==
												'') {
												error = '请填写第' + index + '个包裹的' + ss.label + '金额';
											}
										} else ss.factprice = 0;
										return false;
									}
								});
								if (error == '') {
									baginfo += '"addedservice":' + JSON.stringify(b.addedservice) + ',';
								}
							} else if (b.ishidden == 'False') {
								if (b.isnull == 'False' && b.value == '') error = '请填写第' + index + '个包裹的' +
									b.showname;
								else baginfo += '"' + b.colname + '":"' + b.value + '",';
							}
						});
						if (error != '') {
							list = [];
							return false;
						} else {
							if (baginfo != '') {
								baginfo = baginfo.replace(/\n/g, '');
								baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
							} else {
								baginfo = '{}';
							}
							var orderObj=JSON.parse(JSON.stringify(senderinfo));
							orderObj.idx=index;
							orderObj=that.$public.twoJsonMerge(JSON.parse(JSON.stringify(receiverinfo)),orderObj);
							orderObj=that.$public.twoJsonMerge(JSON.parse(baginfo),orderObj);
							
							var li=[];
							var carlist=JSON.parse(JSON.stringify(cargolist));
							if(carlist.length>0){
								carlist.forEach(r=>{
									li.push(that.$public.twoJsonMerge(JSON.parse(JSON.stringify(r)),orderObj));
								});
							}
							else
								li.push(orderObj);
							if(li.length>0)
								list=list.concat(li);
						}
					});
					orderinfo.list = list;
				}
				if (error != '') {
					this.$tool.message(error, 0);
					orderinfo = '';
					return false;
				}
				return orderinfo;
			},
			//保存订单
			saveorder() {
				var that = this;
				//debugger
				var orderinfo = this.getorderObj();
				if (orderinfo != '') {
					//debugger
					orderinfo.u_userid = localStorage.getItem('userid');
					orderinfo.p_mode = this.checkedpmode;
					orderinfo.t_id = this.t_id;
					orderinfo.otherparam = this.checkedexpress;
					orderinfo.perpay=this.amount;
					
					if (this.iscopy != 1) {
						if (this.$parent.p_pkval != undefined) {
							orderinfo.editid = this.$parent.p_pkval;
							this.$tool.loading('正在保存', this.$parent.divclass);
						} else {
							orderinfo.editid = this.$parent.$parent.p_pkval;
							this.$tool.loading('正在保存', this.$parent.$parent.divclass);
						}
					} else {
						orderinfo.editid = '';
						this.$tool.loading('正在保存', this.$parent.divclass);
					}
					debugger
					//console.log('orderinfo',encodeURIComponent(JSON.stringify(orderinfo)));
					this.$apipost.post.SaveInfo({
						paraminfo: orderinfo
					}).then(res => {
						//this.$tool.loadingclose();
						if (res.state == '1') {
							that.showratewin = false;
							if (that.$parent.p_pkval != undefined)
								that.$parent.p_pkval = res.pkval;
							else
								that.$parent.$parent.p_pkval = res.pkval;
							that.p_pkval = res.pkval;
							//debugger
							//去支付
							this.$tool.loadingclose();
							that.gopay();
							that.saveaddress(orderinfo);
						} else {
							if(res.localfilename!=undefined)
								that.$tool.downfile(that,res.localfilename,'');
							this.$tool.loadingclose();
							that.$tool.message(res.message, 0);
						}
					}).catch(e => {
						this.$tool.loadingclose();
						that.$tool.message('网络异常，请重试', 0);
					});
				}
			},
			cancel() {
				this.$emit('cancel');
			},
			formScrollTop() {
				this.$emit('formScrollTop');
			},
			//预览面单
			perviewmd() {
				this.$tool.loading('正在获取打印模板', this.divclass);
				this.$refs.printhandler.init({
					pageparam: this._data,
					isgrid: false,
					pkval: this.p_pkval,
					searchinfo: '',
					funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
					handtype: 12, //12--取单号+预览
					isrollback: false,
					ecode:'',
					expresscomname:'',
					parentpage: this,
					isprint: 0
				});
			},
			printmd() {
				this.$tool.loading('正在获取打印模板', this.divclass);
				this.$refs.printhandler.init({
					pageparam: this._data,
					isgrid: false,
					pkval: this.p_pkval,
					searchinfo: '',
					funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
					handtype: 13, //13--新方法取单号+打印
					isrollback: false,
					ecode:'',
					expresscomname:'',
					parentpage: this,
					isprint: 1
				});
			},
			successfun(type) {
				var that = this;
				that.showwin = false;
				if (type == 0) {
					//关闭
					this.cancel();
				} else if (type == 1) {
					//复制新增
					this.p_pkval = '';
				} else if (type == 2) {
					this.p_pkval = '';
					this.$parent.p_pkval = '';
					//新增订单，清空界面上所有填写的
					this.init({
						orderinfo: {
							p_mode: ''
						}
					});
					//this.$refs.packagelist._data.isinternational = false;
				}
			},
			//保存收寄件地址用于下次寄件
			saveaddress(orderinfo) {
				var sender = orderinfo.sender;
				var receiver = orderinfo.receiver;
				if (sender != undefined) {
					//debugger
					var paraminfo = {
						u_userid: localStorage.getItem('userid')
					};
					for (var j in sender) {
						var colname = j.substring(2, j.length);
						paraminfo[colname] = sender[j];
					}
					this.$apipost.post.SaveaddressCt({
						paraminfo: paraminfo
					}).then(res => {
						console.log(res);
					});
				}
				if (receiver != undefined) {
					var paraminfo = {
						u_userid: localStorage.getItem('userid')
					};
					for (var j in receiver) {
						var colname = j;
						if (j != 'postcode' && j != 'areacode') colname = j.substring(2, j.length);
						paraminfo[colname] = receiver[j];
					}
					this.$apipost.post.SaveaddressCg({
						paraminfo: paraminfo
					}).then(res => {
						//console.log(res);
					});
				}
			},
			//获取报价单
			getrate() {
				var that = this;
				//debugger
				var orderinfo = this.getorderObj();
				if (orderinfo != '') {
					orderinfo.u_userid = localStorage.getItem('userid');
					orderinfo.p_mode = this.checkedpmode;
					orderinfo.t_id = 'rate_1';
					//console.log('报价', encodeURIComponent(JSON.stringify(orderinfo)));
					//debugger
					this.$tool.loading2('正在获取报价', 'createorder_inner_1' + this.iscopy);
					this.btnhidden = true;
					this.$apipost.post.GetOrderFeeList({
						paraminfo: JSON.stringify(orderinfo)
					}).then(res => {
						that.btnhidden = false;
						this.$tool.loadingclose();
						if (res.state == '1') {
							//console.log('报价单', JSON.stringify(res.list));
							that.showratewin = true;
							that.allratelist = JSON.parse(JSON.stringify(res.list));
							that.expresscom = '';
							that.showallrate();
						} else{
							if(res.localfilename!=undefined)
								that.$tool.downfile(that,res.localfilename,'');
							that.$tool.message(res.message, 0);
						}
					}).catch(e => {
						that.btnhidden = false;
						this.$tool.loadingclose();
						that.$tool.message('网络异常，请重试', 0);

					});
				}
			},
			//报价单列表操作事件
			rategridhandle(e) {
				var that = this;
				if (e.event == 'createorder') {
					//弹出确定框
					that.checkedexpress = {
						rateid: e.row.rateid
					};
					that.ratebatch=e.row.ratebatch;
					//that.checkedpmode = e.row.p_mode;
					that.amount=e.row.amount;
					//console.log('选择报价', this.checkedexpress);
					that.saveorder();
				}
			},
			//报价单筛选快递公司
			showallrate() {
				var that = this;
				var allratelist = JSON.parse(JSON.stringify(this.allratelist));
				var list = JSON.parse(JSON.stringify(this.allratelist));
				if (that.expresscom != '' && that.expresscom != '全部') {
					list = allratelist.filter(function(e) {
						return e.expresscom.toLowerCase().indexOf(that.expresscom.toLowerCase()) > -1;
					});
				}
				if (this.isallrate) {
					//表示查看全部报价
					this.ratelist = list;
				} else {
					//查看最低价
					this.ratelist = list.filter(function(e) {
						return e.minprice == '1';
					});
				}
			},
			//对比国家
			comparecountry(e) {
				//debugger
				var that = this;
				this.$nextTick(function() {
					that.comcountry(e);
				});
			},
			comcountry(e) {
				//debugger
				var that = this;
				var ctcountry = '',
					cgcountry = '';
				var isinternational = true;
				//debugger
				var idx = undefined;
				if (!
					isinternational) { //isinternational=false 表示是同国家的，是否显示填写商品信息按包裹信息中是否有勾选保价，有勾选保价的那一个包裹需要显示商品列表，没勾选的不显示;isinternational=true,表示不同国家的，每个包裹都要显示商品列表
					if (e != undefined) {
						if (e.index != undefined)
							idx = e.index;
					}
				}
				if (that.$refs.packagelist._data.pageset.length > 0) {
					var index = 0;
					that.$refs.packagelist._data.pageset.forEach(ss => {
						if (idx != undefined) {
							if (idx == index) {
								ss.setlist.forEach(c => {
									if (c.controltype == 'table') {
										if (ss.isinternational) {
											if (c.cargolist == undefined) {
												if (e.cargolist != undefined)
													c.cargolist = e.cargolist;
												else
													c.cargolist.splice(1, 0, JSON.parse(JSON.stringify(that
														.$refs.packagelist._data.cargorow)));

											} else {
												if (c.cargolist.length == 0) {
													if (e.cargolist != undefined)
														c.cargolist = e.cargolist;
													else
														c.cargolist.splice(1, 0, JSON.parse(JSON.stringify(
															that.$refs.packagelist._data.cargorow)));
												}
											}
										} else
											c.cargolist = JSON.parse('[' + JSON.stringify(that.$refs
												.packagelist._data.cargorow) + ']');
										return false;
									}
								});
							}
						} else {
							if (isinternational)
								ss.isinternational = isinternational;
							ss.setlist.forEach(c => {
								if (c.controltype == 'table') {
									if (ss.isinternational) {
										if (c.cargolist == undefined) {
											if (e.cargolist != undefined)
												c.cargolist = e.cargolist;
											else
												c.cargolist.splice(1, 0, JSON.parse(JSON.stringify(that
													.$refs.packagelist._data.cargorow)));
										} else {
											if (c.cargolist.length == 0) {
												if (e.cargolist != undefined)
													c.cargolist = e.cargolist;
												else
													c.cargolist.splice(1, 0, JSON.parse(JSON.stringify(that
														.$refs.packagelist._data.cargorow)));
											}
										}
									} else
										c.cargolist = JSON.parse('[' + JSON.stringify(that.$refs
											.packagelist._data.cargorow) + ']');
									return false;
								}
							});
						}
						index++;
					});
				}
			},
			//寄件类型设置完成之后的回调
			sendtypehandle(e){
				debugger
				this.showwin=true;
				//
			},
			//打印方法完成之后的回调
			printcallback(e){
				if(e.issuccess)
					this.$refs.sendtype.init({iswin:'1',pkval:this.p_pkval});
				else
					this.orderRollback(true);
			},
			gopay(){
				this.$refs.orderpay.init({ratebatch:this.ratebatch,pkval:this.p_pkval});
			},
			paycallback(e){
				var that=this;
				//debugger
				if(e.ispay=='1'){//表示支付完成,调用填写寄件类型
					this.$refs.sendtype.init({iswin:'1',pkval:this.p_pkval});
					//进入下单，取单号
					// this.$tool.loading('正在下单', this.$parent.divclass);
					// this.$refs.printhandler.init({
					// 	pageparam: this._data,
					// 	isgrid: false,
					// 	pkval: this.p_pkval,
					// 	searchinfo: '',
					// 	funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
					// 	handtype: 11, //12--取单号+预览
					// 	isrollback: true,
					// 	ecode: '',
					// 	expresscomname: '',
					// 	parentpage: this,
					// 	isreshowrate: true,
					// 	isprint: 0
					// });
				}
				else if(e.ispay=='0'){//支付异常，取消支付
					//订单回滚
					this.orderRollback(false);
				}
			},
			orderRollback(isrefund){
				if(isrefund){
					this.$tool.OrderRefund(this,true,this.p_pkval);
				}else{
					this.$tool.OrderRollback(this,this.p_pkval,'','');
				}
			}
		}
	};
</script>

<style>
	.minprice>td {
		background: #f8c885 !important;
		color: #ffffff;
	}
</style>